import Button from "@src/components/UIElements/Button";
import Modal from "@src/components/UIElements/Modal";
import { Image } from "@src/components/Image";
import React from "react";
import styles from "./PaymentNotSupportedBottomsheet.module.scss";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";

const NotSupportedBottomSheet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showNotSupportedBottomsheet
  );

  return (
    <Modal
      showModal={state}
      handleClose={() => {
        dispatch(actionCreator.setNotSupportedBottomsheet(false));
      }}
    >
      <div className={styles.PaymentFailed}>
        <div className={styles.PaymentFailed__image}>
          {/* todo change the image icon to gif */}
          <Image
            src={getAwsAssets("CrossIcon.png", "content")}
            alt={t(
              "components.bottomSheets.components.paymentFailedBottomSheet.rupeeIcon",
              "RupeeIcon"
            )}
            width="74px"
            height="74px"
          />
        </div>
        <h1 className={styles.PaymentFailed__heading}>
          {t(
            "components.bottomSheets.components.paymentFailedBottomSheet.notSupportedTitle",
            "Payment Not Supported"
          )}
        </h1>
        <p className={styles.PaymentFailed__subtext}>
          {t(
            "components.bottomSheets.components.paymentFailedBottomSheet.notSupportedDesc",
            "Unfortunately payment is not supported on your device. Please use a device with Android version 7 or higher to purchase this course. "
          )}
        </p>
        <Button
          onClick={() => {
            dispatch(actionCreator.setNotSupportedBottomsheet(false));
          }}
        >
          {t(
            "components.bottomSheets.components.paymentFailedBottomSheet.close",
            "Close"
          )}
        </Button>
      </div>
    </Modal>
  );
};

export default NotSupportedBottomSheet;
